<script>
import screenSize from "@/mixins/screenSize"
import BankImgAndAccountOwner from "@/components/ipg/elements/BankImgAndAccountOwner.vue"
import AddBusinessIban from "@/components/modals/addBusinessIban.vue"
import GeneralDialog from "@/components/modals/generalDialog.vue"
import servicesRepository from "@/services/servicesRepository"

export default {
  name: "TerminalIbansList",
  components: {
    GeneralDialog,
    AddBusinessIban,
    BankImgAndAccountOwner,
  },
  mixins: [screenSize],
  props: {
    terminalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpenAddIban: false,
      selectedIban: null,
      isDeleteDialogOpen: false,
      isLoadingBtn: false,
      isOpenDefaultIbanModal: false,
    }
  },
  computed: {
    shaparakTerminalsList() {
      return this.$store.state.ipg.shaparakTerminals
    },
    selectedTerminal() {
      return this.shaparakTerminalsList.find(
        (terminal) => terminal.terminal_id === this.terminalId
      )
    },
    terminalIbansComputed() {
      return this.selectedTerminal?.ibans
    },
    terminalStatus() {
      return this.selectedTerminal?.status
    },
    defaultIbanObject() {
      return (
        this.terminalIbansComputed.length > 0 &&
        this.terminalIbansComputed.find((iban) => iban.is_default === 1)
      )
    },
    isShowDefaultIbanCard() {
      return (
        this.defaultIbanObject &&
        Object.hasOwn(this.defaultIbanObject, "iban") &&
        this.defaultIbanObject?.iban
      )
    },
    isTerminalDisabled() {
      return this.terminalStatus === "DISABLE"
    },
  },
  methods: {
    openAddIbanModal() {
      this.$store.commit("callAddBusinessIbanIsActive", true)
      this.isOpenAddIban = true
    },
    closeModal() {
      this.$store.commit("callAddBusinessIbanIsActive", false)
      this.isOpenAddIban = false
    },
    setSelectedIban(iban) {
      this.selectedIban = iban
    },
    deleteIban(iban) {
      this.setSelectedIban(iban)
      this.isDeleteDialogOpen = true
    },
    cancelDelete() {
      this.setSelectedIban(null)
      this.isDeleteDialogOpen = false
    },
    finalDelete() {
      this.isLoadingBtn = true
      servicesRepository(this)
        .ibanServices.httpDeleteTerminalIban(this.terminalId, this.selectedIban)
        .then((response) => {
          this.$store.commit("callSuccessSnackbar", response.data.message)
          this.$store.commit("addIpg", response.data.data.ipg)
        })
        .finally(() => {
          this.isDeleteDialogOpen = false
          this.isLoadingBtn = false
        })
    },
    openWarnModal(iban) {
      this.isOpenDefaultIbanModal = true
      this.setSelectedIban(iban)
    },
    setDefaultIban() {
      this.isLoadingBtn = true
      servicesRepository(this)
        .ibanServices.httpPostIbanDefault(this.terminalId, this.selectedIban)
        .then((response) => {
          this.$store.commit("callSuccessSnackbar", response.data.message)
          this.$store.commit("addIpg", response.data.data.ipg)
        })
        .finally(() => {
          this.isOpenDefaultIbanModal = false
          this.isLoadingBtn = false
        })
    },
  },
}
</script>

<template>
  <v-card class="headerBox">
    <v-toolbar flat height="60" class="fixed_toolbar">
      <v-btn icon @click.native="$emit('close-modal')">
        <v-icon color="van_color03" size="21"> close </v-icon>
      </v-btn>
      <v-toolbar-title class="pr-0"> شباهای پایانه</v-toolbar-title>
      <v-spacer />
      <v-btn
        text
        dark
        class="btn_small_normal"
        :disabled="isTerminalDisabled"
        @click="openAddIbanModal"
      >
        افزودن شماره شبا
      </v-btn>
    </v-toolbar>
    <v-layout column>
      <v-card
        v-if="isShowDefaultIbanCard"
        flat
        color="van_color11"
        class="w-100 pa-8 d-flex"
        :class="
          reuseIsMobile
            ? 'flex-column align-center'
            : 'flex-row align-center justify-space-between'
        "
      >
        <BankImgAndAccountOwner :iban="defaultIbanObject" />
        <div>
          <v-chip color="van_pink white--text font-size-11">
            حساب پیش‌‌فرض
          </v-chip>
        </div>
      </v-card>

      <v-card
        v-if="terminalIbansComputed?.length > 0"
        color="white"
        class="my-3 py-5 px-10"
      >
        <div
          v-for="(iban, index) in terminalIbansComputed"
          :key="index"
          class="d-flex flex-column"
        >
          <div class="d-flex align-center justify-space-between">
            <BankImgAndAccountOwner :iban="iban" />
            <v-menu
              transition="slide-y-transition"
              offset-y
              close-on-content-click
              bottom
              content-class="up_menu"
            >
              <template #activator="{ on }">
                <v-btn
                  icon
                  size="24"
                  fab
                  small
                  style="margin: 0; float: left"
                  v-on="on"
                >
                  <v-icon
                    :color="'van_color03'"
                    size="21"
                    style="line-height: 40px"
                  >
                    more_vert
                  </v-icon>
                </v-btn>
              </template>

              <v-card outlined class="drop_down_menu">
                <v-list class="menu_v_list">
                  <v-list-item
                    :disabled="isTerminalDisabled"
                    @click="deleteIban(iban.iban)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>حذف شبا</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    :disabled="iban.status !== 'SUCCESS' || isTerminalDisabled"
                    @click="openWarnModal(iban.iban)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        انتخاب به عنوان حساب پیش‌فرض تسویه شاپرک
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </div>
          <v-divider
            v-if="index + 1 < terminalIbansComputed.length"
            class="my-5"
          />
        </div>
      </v-card>
    </v-layout>
    <v-dialog
      v-if="isOpenAddIban"
      v-model="isOpenAddIban"
      content-class="vanmodal"
      transition="slide-x-transition"
      :width="reuseIsMobile ? '100%' : '600'"
      :fullscreen="reuseIsMobile"
      no-click-animation
      @click:outside="closeModal"
    >
      <AddBusinessIban
        :terminal-id="terminalId"
        :is-for-terminal="true"
        @closeModal="closeModal"
      />
    </v-dialog>
    <GeneralDialog
      :active="isDeleteDialogOpen"
      content-class="confirmationMessageDialog"
      style="height: 100%"
      title="از حذف شماره شبا اطمینان دارید؟"
      btn2-text="بلی، حذف شود"
      :btn2-loading="isLoadingBtn"
      btn1-text="خیر، حذف نشود"
      btn2-class="btn_small_normal"
      @btn2Clicked="finalDelete"
      @btn1Clicked="cancelDelete"
    />
    <GeneralDialog
      :active="isOpenDefaultIbanModal"
      content-class="confirmationMessageDialog"
      logo="newIcon/warning.svg"
      title="تغییر شبای پیش‌فرض"
      description="با انتخاب این حساب به عنوان شبای پیش‌فرض، تسویه‌های آتی شاپرک به این حساب انجام خواهد شد."
      description-class="main-des font_30"
      btn1-text="ادامه"
      btn1-class="btn_small_normal outlined"
      :btn1-outlined="true"
      btn2-text="انصراف"
      :btn2-dark-mode="true"
      btn2-class="btn_small_normal error none-border white-text"
      :btn1-loading="isLoadingBtn"
      @btn1Clicked="setDefaultIban"
      @btn2Clicked="isOpenDefaultIbanModal = false"
    />
  </v-card>
</template>

<style scoped lang="scss"></style>
